import React from "react";
import styled from "styled-components";
import { ModeBtn, ModeToggle } from "../../common/MutipleHearings";
import FormField from "../../common/FormField/FormField";

export const PERIOD_MODES = {
  RANGE: "range",
  YEAR: "year",
  MONTH: "month",
};

const MONTH_OPTIONS = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];

const getYearOptions = (span = 10, startYear = new Date().getFullYear()) =>
  Array.from({ length: span }, (_, i) => startYear - i).map((y) => ({
    label: String(y),
    value: y,
  }));

export function buildPeriodPayload({ mode, fromDate, toDate, year, month }) {
  switch (mode) {
    case PERIOD_MODES.RANGE:
      return { fromDate, toDate };
    case PERIOD_MODES.YEAR:
      return { year: Number(year) };
    case PERIOD_MODES.MONTH:
      return { year: Number(year), month: Number(month) };
    default:
      return {};
  }
}

export function isPeriodValid({ mode, fromDate, toDate, year, month }) {
  switch (mode) {
    case PERIOD_MODES.RANGE:
      return !!fromDate && !!toDate && fromDate <= toDate;
    case PERIOD_MODES.YEAR:
      return !!year;
    case PERIOD_MODES.MONTH:
      return !!year && !!month;
    default:
      return false;
  }
}

export const emptyPeriod = {
  mode: PERIOD_MODES.RANGE,
  fromDate: "",
  toDate: "",
  year: "",
  month: "",
};

const PeriodSelector = ({
  mode,
  onModeChange,
  fromDate,
  toDate,
  year,
  month,
  onChange,
  yearsBack = 10,
  disabled = false,
  labels = {},
  values,
  errors,
  touched,
  handleBlur,
  handleChange,
  setFieldValue,
}) => {
  const yearOptions = getYearOptions(yearsBack);

  return (
    <Wrapper>
      <ModeToggle>
        <ModeBtn
          type="button"
          active={values.mode === PERIOD_MODES.RANGE}
          onClick={() => setFieldValue("mode", PERIOD_MODES.RANGE)}
          disabled={disabled}
        >
          {labels.range || "Date Range"}
        </ModeBtn>
        <ModeBtn
          type="button"
          active={values.mode === PERIOD_MODES.YEAR}
          onClick={() => setFieldValue("mode", PERIOD_MODES.YEAR)}
          disabled={disabled}
        >
          {labels.year || "Year"}
        </ModeBtn>
        <ModeBtn
          type="button"
          active={values.mode === PERIOD_MODES.MONTH}
          onClick={() => setFieldValue("mode", PERIOD_MODES.MONTH)}
          disabled={disabled}
        >
          {labels.month || "Month"}
        </ModeBtn>
      </ModeToggle>

      {values.mode === PERIOD_MODES.RANGE && (
        <FieldRow>
          <FieldCol>
            {[
              {
                name: "fromDate",
                label: "From Date",
                type: "date",
                required: true,
              },
            ].map((input, key) => (
              <FormField
                key={key}
                white
                {...{
                  input,
                  values,
                  errors,
                  touched,
                  handleBlur,
                  handleChange,
                  setFieldValue,
                }}
              />
            ))}
          </FieldCol>
          <FieldCol>
            {[
              {
                name: "toDate",
                label: "To Date",
                type: "date",
                required: true,
              },
            ].map((input, key) => (
              <FormField
                key={key}
                white
                {...{
                  input,
                  values,
                  errors,
                  touched,
                  handleBlur,
                  handleChange,
                  setFieldValue,
                }}
              />
            ))}
          </FieldCol>
        </FieldRow>
      )}

      {values.mode === PERIOD_MODES.YEAR && (
        <FieldRow>
          <FieldCol>
            <FormField
              white
              input={{
                type: "select",
                name: "year",
                label: "Year",
                required: true,
              }}
              menuItems={yearOptions}
              {...{
                values,
                errors,
                touched,
                handleBlur,
                handleChange,
                setFieldValue,
              }}
            />
          </FieldCol>
        </FieldRow>
      )}
      {values.mode === PERIOD_MODES.MONTH && (
        <FieldRow>
          <FieldCol>
            <FormField
              white
              input={{
                type: "select",
                name: "month",
                label: "Month",
                required: true,
              }}
              menuItems={MONTH_OPTIONS}
              {...{
                values,
                errors,
                touched,
                handleBlur,
                handleChange,
                setFieldValue,
              }}
            />
          </FieldCol>
          <FieldCol>
            <FormField
              white
              input={{
                type: "select",
                name: "year",
                label: "Year",
                required: true,
              }}
              menuItems={yearOptions}
              {...{
                values,
                errors,
                touched,
                handleBlur,
                handleChange,
                setFieldValue,
              }}
            />
          </FieldCol>
        </FieldRow>
      )}
    </Wrapper>
  );
};

export default PeriodSelector;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const FieldRow = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

const FieldCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 140px;
`;
